import { render, staticRenderFns } from "./industryReportApplication.vue?vue&type=template&id=989610fc&scoped=true"
import script from "./industryReportApplication.vue?vue&type=script&lang=js"
export * from "./industryReportApplication.vue?vue&type=script&lang=js"
import style0 from "./industryReportApplication.vue?vue&type=style&index=0&id=989610fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989610fc",
  null
  
)

export default component.exports